"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
var React = require("react");
var Banner_style_1 = require("./Banner.style");
var ButtonClean_1 = require("../../Button/ButtonClean");
var Icon_1 = require("../../Icon");
exports.Banner = function (props) {
    var image = props.image, isDesktop = props.isDesktop, title = props.title, description = props.description, buttonText = props.buttonText, id = props.id, onButtonClick = props.onButtonClick, pushToHistory = props.pushToHistory, buttonPath = props.buttonPath, ctaOpenPopup = props.ctaOpenPopup, challengeId = props.challengeId;
    var actionProps = {};
    if (buttonPath === 'popup' && ctaOpenPopup && challengeId) {
        actionProps.onClick = function () {
            ctaOpenPopup(challengeId);
        };
    }
    else if (pushToHistory) {
        actionProps.onClick = function () {
            pushToHistory(buttonPath);
        };
    }
    else if (onButtonClick) {
        actionProps.onClick = function () {
            onButtonClick();
        };
    }
    else if (buttonPath) {
        actionProps.href = buttonPath;
    }
    return (React.createElement(Banner_style_1.default.Banner, { "data-test": "Banner", id: id ? "Banner-" + id : null, isDesktop: isDesktop },
        React.createElement(Banner_style_1.default.ContentImage, null,
            React.createElement(Banner_style_1.default.IconImage, { src: image, alt: "" })),
        React.createElement(Banner_style_1.default.Container, null,
            React.createElement(Banner_style_1.default.Title, null, title),
            isDesktop ? React.createElement(Banner_style_1.default.Description, null, description) : undefined,
            buttonText ? (React.createElement(Banner_style_1.default.CtaWrap, { style: { paddingTop: '15px' } },
                React.createElement(ButtonClean_1.default, __assign({ "aria-label": buttonText }, actionProps, { full: true }),
                    buttonText,
                    ' '),
                React.createElement(Icon_1.default, { icon: "chevronRight", colorPrimary: "#25b3eb", size: isDesktop ? 18 : 13, style: { marginTop: '3px' } }))) : null)));
};
exports.default = exports.Banner;
//# sourceMappingURL=Banner.js.map